import styled from "styled-components";

export const DescriptionContainer = styled.div`
  padding: 30px 20px 10px 40px;
  div {
    margin-bottom: 20px;
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }
`;

export const ButtonsContainer = styled.div`
  .button {
    padding: 0 40px !important;
    margin-right: 20px;
  }

  .link {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    padding-right: 64px;
    cursor: pointer;
    transition: all ease .3s;

    &:hover {
      color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.primary.onPrimaryHover}, ${theme.colors.primary.primary})`} !important;
      text-decoration-line: underline;
    }
  }
`;
